import { UserMatterViewHistory } from '@models/userViewHistory';
import { Selector } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';

export class SaleComponentSelector {
	@Selector()
	static ShowRecentlyOpened(): boolean {
		return true; // FT: This selector should be removed during cleanup.
	}
	@Selector([
		SelectedMatter.id,
		SelectedMatter.matterNumber,
		SelectedMatter.matterName,
		SelectedMatter.address,
		SelectedMatter.matterFileType,
		SelectedMatter.matterState,
		SelectedMatter.assignedLawyer,
		SelectedMatter.assignedClerk,
		SelectedMatter.matterSource,
	])
	static GetHistoryObject(
		id,
		number,
		name,
		address,
		fileType,
		state,
		assignedLawyer,
		assignedClerk,
		matterSource,
	): UserMatterViewHistory | null {
		if (!id) {
			return null;
		}

		return {
			id,
			number: number ?? '',
			name: name ?? '',
			address: address ?? null,
			fileType,
			state,
			assignedLawyer: assignedLawyer ?? null,
			assignedClerk: assignedClerk ?? null,
			matterSource: matterSource ?? null,
		};
	}
}
